
const PLANNED = 'Planned'
const EXECUTION = 'Execution'
const FINISHED = 'Finished'
const REVIEWED = 'Reviewed'
const CLOSED = 'Closed'

const TASK_STATUSES = {
  PLANNED: PLANNED,
  EXECUTION: EXECUTION,
  FINISHED: FINISHED,
  REVIEWED: REVIEWED,
  CLOSED: CLOSED
}

const TASK_STATUS_ICONS = {
  [PLANNED]: 'schedule',
  [EXECUTION]: 'hardware',
  [FINISHED]: 'playlist_add_check',
  [REVIEWED]: 'sync',
  [CLOSED]: 'done_all'
}

const TASK_STATUS_LABELS = {
  [PLANNED]: 'Plan',
  [EXECUTION]: 'Ejecución',
  [FINISHED]: 'Terminado',
  [REVIEWED]: 'Revisando',
  [CLOSED]: 'Cerrado'
}

const TASK_STATUS = [
  PLANNED,
  EXECUTION,
  FINISHED,
  REVIEWED,
  CLOSED
]

const PHOTO_TYPES = [
  {
    fileCode: "damage",
    required: true,
    inputFileType: "image/*",
    missingFileLabel: "#Daño"
  },
  {
    fileCode: "process",
    required: true,
    inputFileType: "image/*",
    missingFileLabel: "#Proceso"
  },
  {
    fileCode: "endend",
    required: true,
    inputFileType: "image/*",
    missingFileLabel: "#Terminado"
  },
  {
    fileCode: "RETSAL",
    required: true,
    missingFileLabel: "#Retiro",
    noConceptGrouping: true
  },
  {
    fileCode: "ALMSAL",
    required: true,
    missingFileLabel: "#Almacenamiento",
    noConceptGrouping: true
  },
  {
    fileCode: "CHAINING",
    required: true,
    missingFileLabel: "#Cadenamiento",
    noConceptGrouping: true
  },
  {
    fileCode: "panoramic",
    required: true,
    missingFileLabel: "#Panoramico",
    noConceptGrouping: true
  }
];

export {
  TASK_STATUS_ICONS,
  TASK_STATUS_LABELS,
  TASK_STATUSES,
  PLANNED,
  EXECUTION,
  FINISHED,
  REVIEWED,
  CLOSED,
  PHOTO_TYPES
}



// WEBPACK FOOTER //
// ./src/pages/WorkPlan/WeeklyExecution/utils.js